import parse from 'html-react-parser';
interface MessageInterface {
    message: string,
    isWarning?: boolean
    isSmall?: boolean,
    additionalClasses?: string
}
const Message = ({message, isWarning, isSmall, additionalClasses}: MessageInterface) => {
    return (message ? (
            <div
                className={`form-msg ${isWarning ? 'form-msg--warning' : ''} ${isSmall ? 'form-msg--sm' : ''} ${additionalClasses}`}>
                    {parse(message ?? '')}
            </div>
        ) : ''
    );
}

export default Message;